import { Model } from "pinia-orm";

import Marker from "./Marker";
import Mission from "@/models/Mission";

export default class AosSite extends Model {
  static entity = "aos_sites";
  static primaryKey = "uuid";

  static fields() {
    return {
      uuid: this.uid(""),
      label: this.string(""),
      projectsUuids: this.attr(null),
      marker: this.morphOne(Marker, "markable_id", "markable_type"),
      projects: this.hasManyBy(Mission, "projectsUuids"),
      manualLat: this.attr(null),
      manualLong: this.attr(null),
    };
  }
}
